export default __webpack_public_path__ + "static/media/Image21.5319a147.png";